<app-back-button/>
<div class="page-header">
  <div class="left-area">
    <span class="title">Candidaturas</span>
    <span class="sub-title">Consulte as candidaturas a vagas de emprego das empresas do sector.</span>
  </div>
  <div class="indicator" *ngIf="pagination?.data?.length">
    <div class="icon">
      <img src="icons/image-user-down.svg" alt="Country Icon" />
    </div>
    <div class="text-bg">
      <span>{{candidaturasCount}} Candidaturas em Análise</span>
    </div>
  </div>
</div>

<app-search-bar [sortFields]="sortFields" [showPrimaryBtn]="false" [showFilterBtn]="true"
  (onFilterBtnClick)="showDialog()" (formValueChange)="handleFormValueChange($event)"></app-search-bar>


<ng-container *ngIf="pagination?.data?.length; else noData">
  <p-table [value]="pagination?.data || []" [tableStyle]="{ 'min-width': '60rem' }" stripedRows>
    <ng-template #header>
      <tr>
        <th style="width: 130px">Código</th>
        <th>Empresa</th>
        <th>Vaga</th>
        <th>Candidato</th>
        <th>Data da Candidatura</th>
        <th>Estado</th>
      </tr>
    </ng-template>
    <ng-template #body let-candidatura>
      <tr (click)="actionClick(candidatura)" class="cursor-pointer">
        <td>
          <span class="cand-code-badge" style="font-family: monospace; font-size: 0.85rem; font-weight: 600; padding: 0.2rem 0.5rem; border-radius: 4px; background: #e0f2fe; color: #0369a1;">
            {{ candidatura.codigo || '—' }}
          </span>
        </td>
        <td>{{candidatura.empresa?.nome ||  candidatura.empresa || 'Sem Empresa'}}</td>
        <td>{{candidatura.vaga}}</td>
        <td>{{candidatura.profissional?.nome}}</td>
        <td>
          {{ candidatura.dataCandidatura }}
        </td>
        <td>
          <p-tag [value]="candidatura.estadoCandidatura"
            [severity]="getSeverity(candidatura.estadoCandidatura)"></p-tag>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="pagination-controls">
    <app-paginator-control [first]="((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)"
      [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
      (pageChange)="onPageChange($event)">
    </app-paginator-control>
  </div>
</ng-container>

<ng-template #noData>
  <div class="no-data">
    <app-data-void titulo="Nenhuma Candidatura encontrada" descricao="Tente novamente mais tarde!"></app-data-void>
  </div>
</ng-template>

<p-drawer [(visible)]="showDetalhe" position="right" [style]="{'width': '720px'}"
  styleClass="!w-full md:!w-80 lg:!w-[30rem]">
  <ng-template #headless>
    @if (candidaturaSelecionada) {
    <app-candidatura-detalhe [candidatura]="candidaturaSelecionada" (onCloseModal)="showDetalhe=false" />
    }
  </ng-template>
</p-drawer>


<p-dialog header="Filtros" [modal]="true" [(visible)]="showFilter" [style]="{ width: '40rem' }" appendTo="body">

<form [formGroup]="form" class="p-fluid grid">
  <div *ngFor="let filter of filters" class="field col-6 d-flex flex-column">
      <label>{{ filter.placeholder }}</label>

      <!-- Se for dropdown -->
      <p-select *ngIf="filter.type === 'dropdown'" [filter]="true" [showClear]="true" appendTo="body"
        [options]="filter.options" [formControlName]="filter.controlName" [placeholder]="filter.placeholder"
        [optionLabel]="filter.optionLabel" [optionValue]="filter.optionValue">
      </p-select>

      <!-- Se for texto -->
      <input *ngIf="filter.type === 'text'" pInputText [formControlName]="filter.controlName"
        [placeholder]="filter.placeholder" class="w-full" />
    </div>
</form>


  <div class="flex items-center justify-content-between">
    <p-button label="Cancelar" severity="secondary" (click)="showFilter = false" />
    <p-button label="Pesquisar" (click)="handleFormValueChange(form.value)" />
  </div>
</p-dialog>
